import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MenuComponent } from '../../../menu/menu.component';
import { PayGuard } from '../../../pay.guard';
import { User } from '../../../user';
import { GuserService } from '../../../guser.service';
import { Router } from '@angular/router';
import { Serial } from '../../../serial';
import { LocalService } from '../../../local.service';

@Component({
  selector: 'app-magoris-pay-done',
  templateUrl: './magoris-pay-done.component.html',
  styleUrls: ['./magoris-pay-done.component.scss']
})
export class MagorisPayDoneComponent implements OnInit {


  usernameARR: User;
  serial: number;
  idText: boolean = false;
  numLength: boolean = false;
  date = new Date();
  id: number;

  constructor(private _bottomSheet: MatBottomSheet, private angularFS: AngularFirestore, private user: GuserService
    , private router: Router, private pay: PayGuard, private local: LocalService) { }


  getUser() {
    new Promise(
      (resolve, reject) => {
        this.user.getCurrentUser().then(user => {
          if (user) {
            this.usernameARR = { displayName: user.displayName, email: user.email, uid: user.uid };
          }
          else {
            this.usernameARR = null;
          }
        })
      }
    )
  }

  openBottomSheet(): void {
    this._bottomSheet.open(MenuComponent);
  }

  checkNUm(num) {
    num.length <= 6 ? this.getSerial(num) : this.numLength = true;
  }

  getSerial(num) {
    this.id = num;
    this.local.saveObjToStorage(this.id);
    if (num == 0) {
      this.idText = true;
    }
    else {
      this.idText = false;
      this.numLength = false;
      num = (((((Number(num) + Number(6634)) * Number(2)) + Number(1579)) * Number(2)) - Number(8001));
      this.serial = num;

      this.angularFS.collection<Serial>('users').doc(this.usernameARR.uid).set({ Serial: this.serial, Year: this.date.getFullYear(), Date: this.date.getDate(), Mounth: this.date.getMonth(), email: this.usernameARR.email, id: this.id, displayName: this.usernameARR.displayName, price: '17$' });

      this.router.navigate(['majoris']);


    }
  }


  ngOnInit(): void {
    this.serial = 0;
    this.getUser();



  }
}
